import Settings from 'src/Settings';
import RedesignDescriptor from './account-elements-redesign';
import RefiveDescriptor from './account-elements-refive';
import AramarkDescriptor from './account-elements-aramark';
import CanteenDescriptor from './account-elements-canteen';
import CompanyKitchenDescriptor from './account-elements-companykitchen';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
